import React, { FC, ReactNode, useEffect } from "react";
import { Box, CssBaseline } from "@mui/material";
// import ModalChangeHostDomain from "./AdminMerchant/Retail/Domain/Modals/ModalChangeHostDomain";
import { useRouter } from "../utils/hooks/useRouter";
import { useTranslation } from "react-i18next";
import FlagProvider from "@unleash/proxy-client-react";
import { unleashConfig } from "../utils";
import _ from "lodash";
// import { useLocation } from "react-router-dom";

interface LayoutProps {
  children: ReactNode;
}

const Layout: FC<LayoutProps> = ({ children }) => {
  const router = useRouter();
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  useEffect(() => {
    if (router.query.language) {
      i18n.changeLanguage(router.query.language);
    }
  }, [router.query.language])

  useEffect(() => {
    (window as any).updateTitleNav(t('COMMON.WEBSITE_BUY'), "retail");
  }, [router, t])
  // const location = useLocation()

  // const isAuthenticating = useMemo(() => {
  //   return location.pathname.includes("auth") || location.pathname.includes("/sso")
  // }, [location.pathname])

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          minHeight: "100vh",
          maxWidth: "100vw",
          flexGrow: 1,
          overflow: "hidden",
        }}
      >
        <FlagProvider config={unleashConfig}>
        {children}
        </FlagProvider>
      </Box>
      {/* {
        !isAuthenticating && <ModalChangeHostDomain />
      } */}
    </>
  );
};

export default Layout;
